import {
    BreadcrumbItem,
    Breadcrumbs,
} from "@design-system/Breadcrumbs/Breadcrumbs";
import { StateAwareLink } from "@components/routes/StateAwareLink";

/** One level of the page header trail; a level with a `to` links there. */
export interface Breadcrumb {
    label: string;
    to?: string;
    /** Makes the level a button, even the last one (e.g. "Actions" closing the open task). */
    onClick?: () => void;
}

/**
 * The page header trail: the last level is the current page, earlier levels
 * with a `to` are router links that keep the persisted location state. A
 * level with an `onClick` is a button wherever it sits.
 */
export const HeaderBreadcrumbs = ({
    breadcrumbs,
}: {
    breadcrumbs: Breadcrumb[];
}) =>
    breadcrumbs.length === 0 ? null : (
        <Breadcrumbs>
            {breadcrumbs.map(({ label, to, onClick }, index) => {
                const key = `${label}:${to ?? ""}`;
                if (onClick) {
                    return (
                        <BreadcrumbItem key={key} onClick={onClick}>
                            {label}
                        </BreadcrumbItem>
                    );
                }
                if (index === breadcrumbs.length - 1) {
                    return (
                        <BreadcrumbItem key={key} current>
                            {label}
                        </BreadcrumbItem>
                    );
                }
                if (to) {
                    return (
                        <BreadcrumbItem
                            key={key}
                            render={<StateAwareLink to={to} />}
                        >
                            {label}
                        </BreadcrumbItem>
                    );
                }
                return <BreadcrumbItem key={key}>{label}</BreadcrumbItem>;
            })}
        </Breadcrumbs>
    );
